import * as React from "react";
import { Link } from "react-router-dom";
import { Text } from "..";
import { IText } from "../text/Text";

export interface ILinkRouter extends IText {
  path: string;
  state?: string;
  hideUnderline?: boolean;
}

class LinkRouter extends React.Component<ILinkRouter> {
  public render() {
    const { path, children, hideUnderline, state, ...rest } = this.props;
    return (
      <Link
        to={{
          pathname: path,
          state: state || "",
        }}
      >
        <Text underline={!hideUnderline} {...rest}>
          {children}
        </Text>
      </Link>
    );
  }
}

export default LinkRouter;
